import { render, staticRenderFns } from "./input-box.vue?vue&type=template&id=0bced62c&scoped=true"
import script from "./input-box.vue?vue&type=script&lang=js"
export * from "./input-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bced62c",
  null
  
)

export default component.exports